import React from 'react';
import styled from 'styled-components';

export const Navbar = () => {
    return (
        <Container>
            <h1>Kolektiv MFS</h1>
        </Container>
    );
}

const Container = styled.nav`
    position: absolute;
    top: 0;
    width: 100%;
    padding: 1.25rem;

    h1{
        color: #cd0f1a;
        text-align: center;
        font-family: "Abel", serif;
        text-shadow: 0px 0px 3px #cd0f1a;
    }

    img{
        cursor: pointer;
        display: block;
        margin: auto;
        width: 150px;
    }
`;